import { render, staticRenderFns } from "./CRFList.vue?vue&type=template&id=0df4a3f7&"
import script from "./CRFList.vue?vue&type=script&lang=js&"
export * from "./CRFList.vue?vue&type=script&lang=js&"
import style0 from "./CRFList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports